import { SkeletonProps, Skeleton } from "@mantine/core";

const SkeletonLoader = ({ height, width, ...props }: SkeletonProps) => {
  return (
    <Skeleton height={height || "100%"} width={width || "100%"} {...props} />
  );
};

export default SkeletonLoader;
